import Base from './Base'

import { auth } from '@/services/firebase'

export default class UserReliant extends Base {
  getAll() {
    if (!auth.currentUser) return null

    return super.queryFields({ userId: auth.currentUser.uid })
  }

  _buildData(payload) {
    const _payload = super._buildData(payload)
    const userId = auth.currentUser.uid

    return Object.assign({}, _payload, { userId })
  }

  buildQueryFields(fields) {
    const query = super.buildQueryFields(fields)

    return query.where('userId', '==', auth.currentUser.uid)
  }
}
